import { FormikProps } from "formik";
import React, { FC } from "react";
import { shallowEqual } from "react-redux";
import Message from "../../../../components/feedback/messages/Message/Message";
import { useAppDispatch } from "../../../../store/hooks/dispatch.hook";
import { useAppSelector } from "../../../../store/hooks/selector.hook";
import { setMessageVisiable } from "../../../../store/state/groups/groups.slice";
import { useMessageActions } from "../../../../utl/hooks/useMessageActions";
import { GroupsValue } from "../../models/GroupsValue";
import GroupSettings from "./GroupSettings";

interface Props {
    formik: FormikProps<GroupsValue>;
    active: boolean;
}

const GroupMessage: FC<Props> = ({ formik, active }) => {
    const dispatch = useAppDispatch();

    const message = useAppSelector(state => state.groups.message, shallowEqual);
    const visiable = useAppSelector(state => state.groups.messageVisiable, shallowEqual);

    const setMessage = () => {
        dispatch(setMessageVisiable({ visiable: false }));
    }

    const visiableActions = useMessageActions(visiable, setMessage);

    return (
        <>
            <Message
                content={message || ""}
                visiable={visiableActions}
                position="top"
            />

            <GroupSettings
                formik={formik}
                isNewItemForm={false}
                active={active}
            />
        </>
    );
}

export default GroupMessage;